import { useMemo } from "react";

export const useWoburnColumns = () => useMemo(() => {
  return [
    {
      field: 'shift_date',
      headerName: 'Shift Date'
    },
    {
      field: 'shift_type',
      headerName: 'Shift Type'
    },
    {
      field: 'payback_date',
      headerName: 'Payback Date'
    },
    {
      field: 'status',
      headerName: 'Status'
    },
  ]
}, [])